import React from 'react'
import classNames from 'classnames'
import './SlidePanelFooter.scss'

const SlidePanelFooter = ({ footerProps }) => {
  const { leftActions, rightActions } = footerProps
  return (
    <div className='viso-slide-panel-footer'>
      {leftActions &&
        <div className='viso-slide-panel-footer__buttons'>
          {leftActions.map((left, index) =>
            <button
              key={index}
              onClick={left.onClick}
              className={classNames('viso-slide-panel-footer__button', left.color && `viso-text-${left.color}`)}
            >
              {left.label}
            </button>
          )}
        </div>
      }
      {rightActions &&
        <div className='viso-slide-panel-footer__buttons'>
          {rightActions.map((right, index) => (
            <button
              key={index}
              onClick={right.onClick}
              className={classNames('viso-slide-panel-footer__button', right.color && `viso-text-${right.color}`)}
            >
              {right.label}
            </button>
          ))}
        </div>
      }
    </div>
  )
}

export default SlidePanelFooter